import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Feeding } from '../../components/chemistry/Feeding(March-September)';



const FeedingPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Подкормка (март-сентябрь)</title>
            </Helmet>
            <Feeding />
        </>
    );
};

export default FeedingPage
